import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import {API_BASE_URL} from "../../constants";
import './Payment.css';
import {DatePicker, input} from "antd";
import moment from "moment";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Maskedinput from "react-text-mask";
import LoadingIndicator from "../../common/LoadingIndicator";

class FeeForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            mode: 'create',
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            fieldsDisabled: false,
            isItemLoading: false,
            func: "editFeeDefiniton",
            isopen: false,
            feeDefinition: {
                id: null,
                feeYear: null,
                amount: null,
                feeAccrualGenerationDate: null,
                feeAccrualGenerationStatus: null,
            }
        };

        this.validateClass = this.validateClass.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.saveFeeDefinition = this.saveFeeDefinition.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeAmount = this.onChangeAmount.bind(this);
        this.createAccruals = this.createAccruals.bind(this);
    }

    componentDidMount() {
        let func = this.props.func;
        if (this.props.selectedFeeDefinition) {
            let selectedFeeDefinition = deepCopyObject(this.props.selectedFeeDefinition);
            console.log("selectedFeeDefinition", selectedFeeDefinition);
            let mod = 'edit';
            let fieldsDisabled = selectedFeeDefinition.feeAccrualGenerationStatus && selectedFeeDefinition.feeAccrualGenerationStatus !== "NOT_STARTED";

            selectedFeeDefinition.feeAccrualGenerationDate = (selectedFeeDefinition.feeAccrualGenerationDate !== null) ?
                moment.utc(selectedFeeDefinition.feeAccrualGenerationDate, "YYYY-MM-DD HH:mm:ss")
                : null;

            this.setState({mode: mod, feeDefinition: selectedFeeDefinition, fieldsDisabled, func});
        }
        this.setState({func: func});
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    onChange(e) {
        this.setState({
            feeDefinition: {
                ...this.state.feeDefinition,
                [e.target.name]: e.target.value
            }
        })
    }

    onChangeAmount(e) {
        this.setState({
            feeDefinition: {
                ...this.state.feeDefinition,
                [e.target.name]: e.target.value.toString().substring(0, e.target.value.length - 2)
            }
        })
    }

    onChangeDate(name, value) {
        let feeDefinition = this.state.feeDefinition;
        feeDefinition[name] = value.year();
        this.setState({feeDefinition});
    }

    onSelectChange(name, value) {
        let feeDefinition = this.state.feeDefinition;
        if (value === null) {
            feeDefinition[name] = null
        } else {
            feeDefinition[name] = value.value;
        }
        this.setState({feeDefinition});
    }


    saveFeeDefinition() {
        let self = this;
        let params;
        let data;
        let message;
        let feeDefinition = deepCopyObject(this.state.feeDefinition);
        let validity = this.validateComponent();

        if (validity.valid) {
            self.setState({isLoading: true});
            feeDefinition = trimObject(feeDefinition);
            feeDefinition.amount = feeDefinition.amount.toString().replace(',', '.');
            feeDefinition.feeAccrualGenerationStatus = 'NOT_STARTED';
            data = feeDefinition;

            if (feeDefinition.id === null) {
                message = 'Yıllık Aidat Başarıyla Kaydedildi.'
                params = {
                    url: API_BASE_URL + "/fee-definition",
                    data: data,
                    method: 'post'
                };
            } else {
                message = 'Yıllık Aidat Başarıyla Güncellendi.'
                params = {
                    url: API_BASE_URL + "/fee-definition",
                    data: data,
                    method: 'patch'
                };
            }

            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                self.setState({isLoading: false});
                this.cancelProcess();
                self.props.handleSearch();
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        } else {
            let message = 'Hatalı veya eksik alanlar var!';
            Alert.error(message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }

    /*arrangeDataSet() {
        let dataSet = {};
        let selectedContent = [];

        dataSet.content = selectedContent;
        dataSet.headers = headerContent.feeDefinitonContent;
        dataSet.sheetName = 'Yıllık Tahakkuk Oluşturma Listesi';
        dataSet.uuid = this.create_UUID();

        return dataSet;
    }

    create_UUID() {
        let dt = new Date().getTime();
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }*/

    createAccruals() {
        let self = this;
        let params;
        let data;
        let message;
        let feeDefinition = deepCopyObject(this.state.feeDefinition);
        self.setState({isLoading: true});
        feeDefinition = trimObject(feeDefinition);
        feeDefinition.amount = feeDefinition.amount.toString().replace(',', '.');
        data = feeDefinition;

        message = 'Tahakkuk Oluşturma İşlemi Başarıyla Kuyruğa Alındı.'
        params = {
            url: API_BASE_URL + "/fee-definition/create-accruals/" + feeDefinition.feeYear,
            data: data,
            method: 'post'
        };

        request(params).then(() => {
            Alert.success(
                message, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            self.setState({isLoading: false});
            this.cancelProcess();
            self.props.handleSearch();
        }).catch(function (error) {
            self.setState({isLoading: false});
            showAxiosError(error);
        });
    }

    /*async createAccruals() {
        let self = this;
        let data = self.arrangeDataSet();

        let feeDefinition = deepCopyObject(this.state.feeDefinition);
        feeDefinition=trimObject(feeDefinition);
        feeDefinition.amount=feeDefinition.amount.toString().replace(',','.');

        let message = "İndirme işleminiz sıraya alındı, İndirme işlemi tamamlandıktan sonra 'Bekleyen İndirmeler'" +
            " butonuna tıklayarak tahakkuk excel dosyasını indirebilirsiniz.";

        let params = {
            url: API_BASE_URL + "/fee-definition/create-accruals/" + feeDefinition.feeYear,
            data: data,
            method: 'post',
            timeout: 1500000
        };
        Alert.success(
            message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 10000
            });
        await request(params).then(function (response) {
            self.props.triggerDownloadRequestTooltip();
            self.cancelProcess();
            self.props.handleSearch();
        }).catch(function (error) {
            showAxiosError(error);
        });
    }*/


    cancelProcess() {
        this.props.cancelProcess();
    }

    render() {

        let tFeeAccrualGenerationDate = this.state.feeDefinition.feeAccrualGenerationDate ? {value: this.state.feeDefinition.feeAccrualGenerationDate} : {};
        let feeYear = this.state.feeDefinition.feeYear;
        let feeYearAsMoment = feeYear !== null ? {value: moment.utc('01/01/' + feeYear, "DD/MM/YYYY")} : {};
        console.log("fieldsDisabled", this.state.fieldsDisabled);
        const numberMask = createNumberMask({
            prefix: '',
            suffix: ' ₺',
            allowDecimal: true,
            decimalSymbol: ',',
            includeThousandsSeparator: false,
        });
        return (
            <div className='fee-definition-form-container'>
                {/* HEADER */}
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'>
                    <h4 className="card-title">{(this.props.func && this.props.func === "editFeeDefiniton") ? (this.props.mode === "create") ? 'Yeni Aidat Tanımı Oluştur' : 'Aidat Tanımı Düzenle' : 'Tüm Aktif Üyeler İçin Yıllık Aidat Tahakkuku Oluştur'}</h4>
                </div>
                <div className="card-body mt-1">
                    <div className="FormRenk col-sm-12">

                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Dönem *</label>
                            </div>
                            <div className="col-sm-6">
                                <DatePicker {...feeYearAsMoment}
                                            placeholder="Dönem seçiniz."
                                            disabled={this.state.fieldsDisabled}
                                    //picker="year"
                                            mode="year"
                                            onOpenChange={(status) => {
                                                if (status) {
                                                    this.setState({isopen: true})
                                                } else {
                                                    this.setState({isopen: false})
                                                }
                                            }}
                                            open={this.state.isopen}
                                            isClearable={true}
                                            isSearchable={true}
                                            format="YYYY"
                                            name="feeYear"
                                            id="tFeeYear"
                                            ref="tFeeYear"
                                            style={{width: 200}}
                                            inputProps={{'vdata': "required"}}
                                            onPanelChange={(dateString) => {
                                                this.setState({isopen: false});
                                                this.onChangeDate("feeYear", dateString)
                                            }}/>
                                {this.validateMessage('tFeeYear') !== "" &&
                                <UncontrolledTooltip placement="right" target="tFeeYear" delay={0}>
                                    {this.validateMessage("tFeeYear")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Tutar *</label>
                            </div>
                            <div className="col-sm-6">
                                <div className={"form-group" + this.validateClass('tAmount')}>
                                    <Maskedinput className="form-control"
                                                 mask={numberMask}
                                                 type="text"
                                                 disabled={this.state.fieldsDisabled}
                                                 name="amount"
                                                 id="tAmount"
                                                 maxLength="12"
                                                 inputProps={{vdata: "required", vlength: '3,12'}}
                                                 placeholder="________,__₺"
                                                 onBlur={this.validateField}
                                                 ref="tAmount"
                                                 value={this.state.feeDefinition.amount && this.state.feeDefinition.amount.toString().replace('.', ',') + ' ₺'}
                                                 onChange={(e) => this.onChangeAmount(e)}
                                    />
                                    {this.validateMessage('tAmount') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tAmount" delay={0}>
                                        {this.validateMessage("tAmount")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Tahakkuk Durumu</label>
                            </div>
                            <div className="col-sm-6">
                                <div className={"form-group" + this.validateClass('TFeeAccrualGenerationCompleted')}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={true}
                                           name="feeAccrualGenerationCompleted"
                                           id="TFeeAccrualGenerationCompleted"
                                           data-vlength="1,255"
                                           value={this.state.feeDefinition.feeAccrualGenerationStatus &&
                                           this.state.feeDefinition.feeAccrualGenerationStatus === "NOT_STARTED" ? "OLUŞTURULMADI" :
                                               (this.state.feeDefinition.feeAccrualGenerationStatus === "STARTED" ||
                                                   this.state.feeDefinition.feeAccrualGenerationStatus === "SCHEDULED") ? "OLUŞTURULUYOR" : "OLUŞTURULDU"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Tahakkuk Oluşturulma Tarihi</label>
                            </div>
                            <div className="col-sm-6">
                                <DatePicker {...tFeeAccrualGenerationDate}
                                            placeholder=""
                                            disabled={true}
                                            isClearable={true}
                                            isSearchable={true}
                                            format="DD.MM.YYYY"
                                            name="feeYear"
                                            id="tFeeYear"
                                            style={{width: 200}}/>
                            </div>
                        </div>
                    </div>
                </div>
                {/* CARD FOOTER */}
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                İptal
                            </button>
                        </div>
                        <div className="col-sm-8"/>
                        <div className='col-sm-2'>
                            {(this.state.func === "editFeeDefiniton") &&
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"150px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    disabled={this.state.fieldsDisabled || this.state.isLoading}
                                    onClick={() => this.saveFeeDefinition()}>{this.state.mode === 'create' ? 'Kaydet' : 'Güncelle'}
                            </button>
                            }
                            {(this.state.func !== "editFeeDefiniton") &&
                            // (this.state.feeDefinition.feeAccrualGenerationStatus === "NOT_STARTED") &&
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px'
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    disabled={this.state.fieldsDisabled || this.state.isLoading}
                                    onClick={() => this.createAccruals()}>Yıllık Tahakkukları Oluştur
                            </button>
                            }
                            {/*{ (this.state.func !== "editFeeDefiniton") &&
							(this.state.feeDefinition.feeAccrualGenerationStatus === "FINISHED") &&
								<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{
								background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
								float: 'right', padding: '10px 54px 10px 23px'
							}}
								rel="tooltip" className="TekBtn kaydet"
								disabled={this.state.isLoading}
								onClick={() => this.createAccruals()}>Yıllık Tahakkukları Oluştur
								</button>
							}*/}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FeeForm;


// WEBPACK FOOTER //
// ./src/page/financial/FeeForm.js